module.exports = __webpack_public_path__ + "static/media/ypsilibrary1.2fa56844.jpg";